import TradlyFooter from '@/partials/TradlyFooter'
import Integrations from '@/components/Integration/Index/Integrations'
import IntegrationsNewsletter from '@/components/Integration/Index/IntegrationsNewletter'
import { tradly_api_call } from '@/WebHandler/tradly_api_call'
import Head from 'next/head'
import { useRouter } from 'next/router'
import React from 'react'

const Index = ({ categories, integrations }) => {
  const router = useRouter()
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.
"
        />
        <meta
          key="og:title"
          property="og:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE.
"
        />
        <title>Tradly – Integrations</title>
      </Head>
      <div className=" min-h-[60%] max-w-6xl mx-auto pt-12 mb-20 space-y-20 overflow-hidden   sm:mb-32 sm:space-y-32  md:mb-40 md:space-y-40 sm:px-4 md:px-8">
        <Integrations categories={categories?.categories} integrations={integrations} />
        <IntegrationsNewsletter />
      </div>
      <TradlyFooter />
    </>
  )
}

export default Index

export async function getServerSideProps({ params, req, res, query }) {
  const { category_id, page } = query

  const categories = await tradly_api_call({
    method: 'GET',
    path: `/v1/categories`,
    params: {
      parent: 0,
      type: 'listings',
    },
    onSuccess: (res) => {
      return res?.categories
    },
    onError: (err) => {
      console.log(err)
      return {}
    },
  })

  let params_data = {
    page: page ? page : 1,
    category_id: 4047,
    type: 'listings',
    include: 'attributes',
    status: 2,
    sort: 'oldest_first',
  }
  if (category_id) {
    params_data.category_id = category_id
  }

  const integrations = await tradly_api_call({
    method: 'GET',
    path: '/products/v1/listings',
    params: params_data,
    onSuccess: (res) => {
      return res?.listings
    },
    onError: (err) => {
      console.log(err)
      return {}
    },
  })

  return {
    props: { categories, integrations }, // will be passed to the page component as props
  }
}
